export const GPX_EVENT_TYPES = {
  CLICK: 'click',
  API_RESPONSE: 'api_response',
  API_REQUEST: 'api_request',
  API_PUSH: 'api_push',
  INFO: 'info',
  VIEW: 'view',
  HOVER: 'hover',
} as const;

export const GPX_CAPABILITIES = {
  VIDEO_STREAMING: 'video_streaming',
  MEDIA_UPLOAD: 'media_upload',
  TF911: 'text_from_911',
  AIR_AMBULANCE: 'air_ambulance',
  TT911: 'text_to_911',
  ROADSIDE_ASSISTANCE: 'roadside_assistance',
  COMMUNICATOR_SUMMARIZATION_AND_KEYWORDS:
    'communicator_summarization_and_keywords',
  LIVE_VIDEO: 'live_video',
  CONNECT_SHARE_VIEW: 'connect_share_view',
  INTELLIGENT_ANALYST: 'intelligent_analyst',
  INTELLIGENT_ANALYST_HARMONY: 'intelligent_analyst_harmony',
  APP_LAUNCHER: 'app_launcher',
  UNITE_EVENT_PANE: 'unite_event_pane',
  AGENCY_SHARE_CHAT: 'agency_share_chat',
  GIS: 'gis',
  CALLS: 'calls',
  NOTIFIER: 'notifier',
  NAVIGATION: 'navigation',
  RESOURCE_REQUEST: 'resource_request',
  TEXT_TO_VOICE_TRANSLATION: 'text_to_voice_translation',
  PERMISSIONS: 'permissions',
  LEGACY: 'legacy',
} as const;

export const GPX_FEATURES = {
  CIRCUS_LIVE_VIDEO: 'circus_live_video',
  CIRCUS_MEDIA_UPLOAD: 'circus_media_upload',
  CIRCUS_DISPLAY_MEDIA: 'circus_display_media',
  TF911: 'text_from_911',
  TF911_PRECONFIGURED_RESPONSES: 'tf911_preconfigured_responses',
  TF911_OUTBOUND: 'text_from_911_outbound',
  VT911: 'video_to_911',
  GMR_AIR_AMBULANCE: 'gmr_air_ambulance',
  RCS911: 'rcs_to_911',
  TT911: 'text_to_911',
  ROADSIDE_ASSISTANCE: 'agero_roadside_assistance',
  KEYWORD_DETECTION: 'keyword_detection',
  CONNECT_SHARE_VIEW: 'connect_share_view',
  CALL_TRANSCRIPTION: 'call_transcription',
  INTELLIGENT_ANALYST: 'intelligent_analyst',
  INTELLIGENT_ANALYST_CHARTS: 'intelligent_analyst_charts',
  INTELLIGENT_ANALYST_MAPS: 'intelligent_analyst_maps',
  INTELLIGENT_ANALYST_FILTERS: 'intelligent_analyst_filters',
  INTELLIGENT_ANALYST_EXPORT: 'intelligent_analyst_export',
  INTELLIGENT_ANALYST_NAVIGATION: 'intelligent_analyst_navigation',
  INTELLIGENT_ANALYST_HARMONY_CHAT: 'intelligent_analyst_harmony_chat',
  INTELLIGENT_ANALYST_HARMONY_DASHBOARD:
    'intelligent_analyst_harmony_dashboard',
  APP_LAUNCHER: 'app_launcher',
  ADR_DATA: 'adr_data',
  EVENT_PANE_NAVIGATION: 'event_pane_navigation',
  AGENCY_SHARE_CHAT: 'agency_share_chat',
  LIVE_VIDEO_TC: 'live_video_telecommunicator',
  LIVE_VIDEO_CALLER: 'live_video_caller',
  GIS: 'gis',
  CALLS: 'calls',
  NOTIFIER: 'notifier',
  NAVIGATION: 'navigation',
  RESOURCE_REQUEST: 'resource_request',
  TEXT_TO_VOICE_TRANSLATION: 'text_to_voice_translation',
  ALERTS: 'alerts',
  LEGACY: 'legacy',
} as const;

export const GPX_PARTNERS = {
  CIRCUS: 'circus',
  GMR: 'GMR',
  GOOGLE: 'google',
  AGERO: 'agero',
} as const;

export const GPX_ROUTES = {
  MEDIA: 'Media',
  COMMUNICATOR: 'Communicator',
  MAP: 'Map',
  CALL_QUEUE: 'Call Queue',
  ADMIN: 'Admin',
  CONNECT_SHARE: 'Connect Share',
  TOOLS: 'Tools',
  EVENT_PANE: 'Event Pane',
  INTELLIGENT_ANALYST_SUMMARY: 'Intelligent Analyst Summary',
  INTELLIGENT_ANALYST_ANSWER_TIME_METRICS:
    'Intelligent Analyst Answer Time Metrics',
  INTELLIGENT_ANALYST_ADDITIONAL_METRICS:
    'Intelligent Analyst Additional Metrics',
  INTELLIGENT_ANALYST_AGENT_METRICS: 'Intelligent Analyst Agent Metrics',
  INTELLIGENT_ANALYST_HEATMAP: 'Intelligent Analyst Heatmap',
  INTELLIGENT_ANALYST_HARMONY_DASHBOARD:
    'Intelligent Analyst HARMONY Dashboard',
  INTELLIGENT_ANALYST_ALARM_CALL_SUMMARY:
    'Intelligent Analyst Alarm Call Summary',
  INTELLIGENT_ANALYST_ALARM_CALL_LIST: 'Intelligent Analyst Alarm Call List',
  INTELLIGENT_ANALYST_PDE_METRICS_SUMMARY:
    'Intelligent Analyst PDE Metrics Summary',
  LIVE_VIDEO: 'Live video caller UI',
  NOTIFIER_LOGIN: 'Notifier Login',
  NOTIFIER_MAP_OVERVIEW: 'Notifier Map Overview',
  NOTIFIER_INCIDENT_LIST: 'Notifier Incident List',
  NOTIFIER_INCIDENT_DETAIL: 'Notifier Incident Detail',
  NAVBAR: 'Navigation Bar',
  RESOURCE_REQUEST_PANEL: 'Resource Request Panel',
  ICSP: 'iCSP',
} as const;

/**
 * These are root level event name identifiers (e.g., UNITE_USAGE).
 * Use specific names to distinguish different products/apps.
 */
export const GPX_EVENT_NAME = {
  UNITE_USAGE: 'UNITE usage',
  CONNECT_SHARE_USAGE: 'Connect Share usage',
  INTELLIGENT_ANALYST_USAGE: 'Intelligent Analyst usage',
  NOTIFIER_USAGE: 'Notifier usage',
} as const;

// Export type definitions for better TypeScript integration
export type GPXEventType =
  (typeof GPX_EVENT_TYPES)[keyof typeof GPX_EVENT_TYPES];
export type GPXCapability =
  (typeof GPX_CAPABILITIES)[keyof typeof GPX_CAPABILITIES];
export type GPXFeature = (typeof GPX_FEATURES)[keyof typeof GPX_FEATURES];
export type GPXPartner = (typeof GPX_PARTNERS)[keyof typeof GPX_PARTNERS];
export type GPXRoute = (typeof GPX_ROUTES)[keyof typeof GPX_ROUTES];
export type GPXEventName = (typeof GPX_EVENT_NAME)[keyof typeof GPX_EVENT_NAME];
